import { GetMethod, PostMethod } from '../../serviceHelper';

const getMethods = (service: 'hr', controller: 'PropertyTypes') => ({
	GetAll: new GetMethod<Array<any>, null>({
		service,
		controller,
		method: 'GetAll'
	}),
	Insert: new PostMethod<number, any>({
		service,
		controller,
		method: 'Insert'
	}),
	Update: new PostMethod<number, any>({
		service,
		controller,
		method: 'Update'
	}),
	Delete: new PostMethod<boolean, any>({
		service,
		controller,
		method: 'Delete'
	}),
	GetAllWithLoadOptions: new PostMethod<boolean, any>({
		service,
		controller,
		method: 'GetAllWithLoadOptions'
	}),
	GetAllByUsage: new PostMethod<boolean, any>({
		service,
		controller,
		method: 'GetAllByUsage'
	})
});

export { getMethods };
